import CalloutCard from 'components/Callouts/CalloutCard/CalloutCard';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import Media from 'components/shared/Media/Media';
import { CalloutImageProps } from 'components/Callouts/types';
import { getCalloutColumns, getSectionProps } from 'utils/styles';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const CalloutImage = ({ sys, content, headline, sectionName, columns, color, margins }: CalloutImageProps) => {
  return (
    <section {...getSectionProps(color, margins, sectionName)}>
      <div className="content-wrapper">
        <div className="flex flex-col items-start w-full gap-8">
          {headline && (
            <div className="text-heading-lg font-sans font-semibold md:w-1/2" {...liveUpdateAttrs(sys?.id, 'headline')}>
              <RichTextHeadline headline={headline} />
            </div>
          )}

          <div
            className="callout-image-cards flex flex-col md:flex-row md:flex-wrap items-start gap-6 md:gap-y-16 w-full"
            {...liveUpdateAttrs(sys?.id, 'content')}>
            {(content?.items ?? []).map((item, index) => (
              <CalloutCard
                sys={sys}
                key={index}
                showTopKeylineDesktop={!item.image}
                showTopKeylineMobile={!item.image}
                className={getCalloutColumns(columns)}
                headline={item.headline}
                headlineSmallRte={item.headlineSmallRte}
                copy={item.copy}
                copyJustification={item.copyJustification}
                attributionRte={item.attributionRte}
                defaultAlignment="col">
                {item.image && (
                  <div
                    className="flex mt-5 justify-center relative w-full h-64 rounded-lg"
                    {...liveUpdateAttrs(sys?.id, 'image')}>
                    <Media
                      media={item.image}
                      className="object-cover h-full w-auto"
                      sizes="(max-width: 375px) 100vw, 425px"
                    />
                  </div>
                )}
              </CalloutCard>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CalloutImage;
